var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 179,
    viewBox: "0 0 129 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-2--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M123.983 30.6035H5.01172V178.347H123.983V30.6035Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.954 164.564H13.085V167.046H18.954V164.564Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6796 167.691H9.81055V170.173H15.6796V167.691Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.2285 167.691H16.3594V170.173H22.2285V167.691Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M115.91 167.691H110.041V170.173H115.91V167.691Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M115.91 128.132H110.041V130.614H115.91V128.132Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M119.184 131.265H113.314V133.747H119.184V131.265Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.6796 128.138H9.81055V130.621H15.6796V128.138Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M87.5097 65.481H81.6406V67.9634H87.5097V65.481Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M71.5635 146.638H77.4326V144.155H71.5635V146.638Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M74.8379 143.511H80.707V141.028H74.8379V143.511Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M45.2676 57.9751H51.1367V55.4927H45.2676V57.9751Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M48.542 54.8481H54.4111V52.3658H48.542V54.8481Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M47.9454 107.416H53.8145V104.934H47.9454V107.416Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M51.2256 110.542H57.0947V108.06H51.2256V110.542Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M44.6709 110.542H50.54V108.06H44.6709V110.542Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.085 82.4204H18.9541V79.938H13.085V82.4204Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M9.81059 85.5469H15.6797V83.0645H9.81059V85.5469Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M113.32 82.4204H119.189V79.938H113.32V82.4204Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M125.863 175.876H3.1377V178.347H125.863V175.876Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M73.7028 131.891H55.5459V173.24H73.7028V131.891Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M63.2827 138.623L60.6289 138.7L57.9219 138.747H57.8037V138.623V136.489V134.208H57.9456H60.623C61.5155 134.208 62.3961 134.208 63.3064 134.238H63.4127V134.344V135.426V136.501L63.2827 138.623ZM63.2827 138.623L63.2177 136.466V135.408V134.356L63.3241 134.462L60.6407 134.492H57.9633L58.111 134.344V136.478V138.611L57.9869 138.493L60.6348 138.54L63.2827 138.623Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M70.6831 138.623L68.0352 138.7L65.3282 138.747H65.2041V138.623V136.489V134.208H65.3519H68.0293C68.9218 134.208 69.8024 134.208 70.7067 134.238H70.8131V134.344V135.426V136.501L70.6831 138.623ZM70.6831 138.623L70.624 136.466L70.5944 135.408V134.356L70.7008 134.462L68.0234 134.492H65.3459L65.4878 134.344V136.478V138.611L65.3696 138.493L68.0175 138.54L70.6831 138.623Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M63.2826 153.281L60.617 153.322C59.7245 153.322 58.8438 153.358 57.9218 153.364H57.845V153.281L57.8154 150.214C57.8154 149.193 57.8154 148.171 57.8154 147.146V141.017V140.869H57.9573H63.3181H63.4481V140.999C63.4481 142.028 63.4481 143.056 63.4481 144.084L63.4126 147.164L63.3772 150.225L63.2826 153.281ZM63.2826 153.281L63.1999 147.117L63.1644 144.061C63.1644 143.044 63.1644 142.028 63.1644 141.017L63.2944 141.147H57.9336L58.0814 141.005V147.134C58.0814 148.159 58.0814 149.181 58.0814 150.202L58.0518 153.269L57.9691 153.192L60.6288 153.228L63.2826 153.281Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M70.682 153.281L68.0223 153.322C67.1239 153.322 66.2492 153.358 65.3271 153.364H65.2444V153.281L65.2148 150.214C65.2148 149.193 65.2148 148.171 65.2148 147.146V141.017V140.869H65.3626H70.7175H70.8475V140.999C70.8475 142.028 70.8475 143.056 70.8475 144.084L70.8121 147.164L70.7766 150.225L70.682 153.281ZM70.682 153.281L70.5993 147.117L70.5638 144.061C70.5638 143.044 70.5638 142.028 70.5638 141.017L70.6939 141.147H65.339L65.4808 141.005V147.134C65.4808 148.159 65.4808 149.181 65.4808 150.202L65.4513 153.269L65.3744 153.192L68.0341 153.228L70.682 153.281Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M63.2826 167.939L60.617 167.98C59.7245 167.98 58.8438 168.016 57.9218 168.022H57.845V167.939L57.8154 164.871C57.8154 163.847 57.8154 162.824 57.8154 161.804V155.675V155.527H57.9573H63.3181H63.4481V155.657C63.4481 156.685 63.4481 157.714 63.4481 158.742L63.4126 161.821L63.2826 164.907V167.939ZM63.2826 167.939L63.1999 161.774L63.1644 158.719C63.1644 157.702 63.1644 156.685 63.1644 155.675L63.2944 155.805H57.9336L58.0814 155.663V161.792C58.0814 162.816 58.0814 163.839 58.0814 164.859L58.0518 167.927L57.9691 167.844C58.8557 167.844 59.7422 167.874 60.6288 167.886L63.2826 167.939Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M70.682 167.939L68.0223 167.98C67.1239 167.98 66.2492 168.016 65.3271 168.022H65.2444V167.939L65.2148 164.871C65.2148 163.847 65.2148 162.824 65.2148 161.804V155.675V155.527H65.3626H70.7175H70.8475V155.657C70.8475 156.685 70.8475 157.714 70.8475 158.742L70.8121 161.821L70.7766 164.883L70.682 167.939ZM70.682 167.939L70.5993 161.774L70.5638 158.719C70.5638 157.702 70.5638 156.685 70.5638 155.675L70.6939 155.805H65.339L65.4808 155.663V161.792C65.4808 162.816 65.4808 163.839 65.4808 164.859L65.4513 167.927L65.3744 167.844C66.2551 167.844 67.1476 167.874 68.0341 167.886L70.682 167.939Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M73.0523 153.281H71.4033V157.791H73.0523V153.281Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.32,
    d: "M72.8933 154.067C72.8909 154.199 72.8496 154.327 72.7746 154.435C72.6995 154.544 72.5941 154.627 72.4715 154.676C72.3489 154.725 72.2147 154.736 72.0858 154.708C71.9569 154.681 71.839 154.616 71.747 154.521C71.655 154.427 71.5931 154.307 71.5689 154.177C71.5448 154.048 71.5595 153.914 71.6113 153.793C71.6631 153.672 71.7496 153.568 71.8599 153.496C71.9703 153.424 72.0995 153.386 72.2313 153.387C72.409 153.39 72.5782 153.463 72.7022 153.591C72.8262 153.718 72.8949 153.889 72.8933 154.067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M83.2835 175.593H45.9648V178.347H83.2835V175.593Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M83.7566 175.032H45.4922V175.599H83.7566V175.032Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M80.7893 172.277H48.4531V175.032H80.7893V172.277Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M81.2623 171.71H47.9805V172.277H81.2623V171.71Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M122.121 0.377197H6.87922L0.96875 43.5591H128.032L122.121 0.377197Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M1.70703 38.1683L17.4052 38.0973L33.1093 38.0737L64.5116 38.0205L95.9198 38.0737L111.618 38.0973L127.322 38.1683L111.618 38.2392L95.9198 38.2687L64.5116 38.316L33.1093 38.2687L17.4052 38.2392L1.70703 38.1683Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M2.44043 32.7781L17.9554 32.7072L33.4704 32.6835L64.5003 32.6362L95.5243 32.6835L111.039 32.7072L126.554 32.7781L111.039 32.8549L95.5243 32.8786L64.5003 32.9258L33.4704 32.8786L17.9554 32.8549L2.44043 32.7781Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M3.17969 27.3939L18.5114 27.3229L33.8432 27.2934L64.5008 27.2461L95.1584 27.2934L110.49 27.3229L125.816 27.3939L110.49 27.4648L95.1584 27.4884L64.5008 27.5416L33.8432 27.4884L18.5114 27.4648L3.17969 27.3939Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M3.91797 22.0035L19.0665 21.9326L34.2091 21.903L64.5002 21.8557L94.7914 21.903L109.934 21.9326L125.077 22.0035L109.934 22.0744L94.7914 22.104L64.5002 22.1512L34.2091 22.098L19.0665 22.0744L3.91797 22.0035Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M4.65723 16.6136L19.6166 16.5427L34.576 16.519L64.5007 16.4658L94.4195 16.519L109.379 16.5427L124.344 16.6136L109.379 16.6845L94.4195 16.7141L64.5007 16.7613L34.576 16.7141L19.6166 16.6845L4.65723 16.6136Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M5.39551 11.2229L20.1717 11.152L34.9478 11.1283L64.5002 11.0811L94.0525 11.1283L108.829 11.152L123.605 11.2229L108.829 11.2997L94.0525 11.3234L64.5002 11.3707L34.9478 11.3234L20.1717 11.2997L5.39551 11.2229Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M6.13477 5.83844L20.7218 5.76751L35.3147 5.73795L64.5006 5.69067L93.6806 5.73795L108.274 5.76751L122.866 5.83844L108.274 5.90936L93.6806 5.933L64.5006 5.9862L35.3147 5.933L20.7218 5.90936L6.13477 5.83844Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M35.8524 141.714V158.482H16.2119V141.714C16.1798 140.404 16.41 139.101 16.8891 137.882C17.3682 136.662 18.0864 135.551 19.0015 134.613C19.9165 133.675 21.01 132.93 22.2174 132.421C23.4249 131.912 24.7219 131.65 26.0322 131.65C27.3425 131.65 28.6395 131.912 29.8469 132.421C31.0544 132.93 32.1478 133.675 33.0629 134.613C33.978 135.551 34.6962 136.662 35.1752 137.882C35.6543 139.101 35.8846 140.404 35.8524 141.714Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M34.7235 141.714V157.354H17.3408V141.714C17.3106 140.554 17.513 139.399 17.9362 138.318C18.3594 137.237 18.9947 136.252 19.8048 135.421C20.6148 134.589 21.5832 133.928 22.6527 133.477C23.7223 133.026 24.8714 132.793 26.0322 132.793C27.193 132.793 28.3421 133.026 29.4116 133.477C30.4812 133.928 31.4495 134.589 32.2596 135.421C33.0697 136.252 33.705 137.237 34.1282 138.318C34.5514 139.399 34.7538 140.554 34.7235 141.714Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M33.4704 137.228L17.3467 153.352V147.577L30.6039 134.32C31.7791 135.045 32.7624 136.042 33.4704 137.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M34.5056 139.787L17.3652 156.928V155.704L34.2514 138.818C34.3613 139.134 34.4463 139.458 34.5056 139.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M26.8508 133.061L17.3467 142.571V141.714C17.3447 141.142 17.4002 140.572 17.5122 140.012L24.3388 133.185C24.8956 133.076 25.4617 133.02 26.0292 133.02C26.3129 133.02 26.5848 133.037 26.8508 133.061Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M34.7176 141.554H17.3408V142.683H34.7176V141.554Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M23.4336 141.56V132.671H22.3047V141.56H23.4336Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M29.7646 141.56V132.671H28.6357V141.56H29.7646Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M37.6611 158.482H14.3975V162.525H37.6611V158.482Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M112.789 141.714V158.482H93.1485V141.714C93.1163 140.404 93.3466 139.101 93.8256 137.882C94.3047 136.662 95.0229 135.551 95.938 134.613C96.8531 133.675 97.9465 132.93 99.1539 132.421C100.361 131.912 101.658 131.65 102.969 131.65C104.279 131.65 105.576 131.912 106.783 132.421C107.991 132.93 109.084 133.675 109.999 134.613C110.914 135.551 111.633 136.662 112.112 137.882C112.591 139.101 112.821 140.404 112.789 141.714Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M111.654 141.714V157.353H94.2773V141.714C94.2773 140.573 94.5021 139.443 94.9387 138.389C95.3753 137.335 96.0153 136.377 96.8221 135.571C97.6289 134.764 98.5867 134.124 99.6408 133.687C100.695 133.251 101.825 133.026 102.966 133.026C104.107 133.026 105.237 133.251 106.291 133.687C107.345 134.124 108.303 134.764 109.109 135.571C109.916 136.377 110.556 137.335 110.993 138.389C111.429 139.443 111.654 140.573 111.654 141.714Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M110.407 137.228L94.2773 153.352V147.577L107.535 134.32C108.712 135.045 109.697 136.042 110.407 137.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M111.441 139.787L94.3008 156.928V155.704L111.157 138.842C111.273 139.15 111.368 139.466 111.441 139.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M103.787 133.061L94.2773 142.571V141.714C94.2783 141.143 94.3337 140.573 94.4428 140.012L101.269 133.186C101.828 133.076 102.396 133.021 102.966 133.02C103.244 133.02 103.515 133.038 103.787 133.061Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M111.654 141.554H94.2773V142.683H111.654V141.554Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M100.37 141.554V132.665H99.2412V141.554H100.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M106.695 141.554V132.665H105.566V141.554H106.695Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M114.598 158.482H91.334V162.525H114.598V158.482Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M35.8524 101.558V118.332H16.2119V101.558C16.2748 98.9956 17.337 96.5589 19.1718 94.7686C21.0066 92.9782 23.4686 91.9761 26.0322 91.9761C28.5957 91.9761 31.0577 92.9782 32.8925 94.7686C34.7273 96.5589 35.7895 98.9956 35.8524 101.558Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M34.7235 101.558V117.203H17.3408V101.558C17.3999 99.2926 18.3415 97.1394 19.965 95.5577C21.5885 93.976 23.7655 93.0908 26.0322 93.0908C28.2988 93.0908 30.4758 93.976 32.0993 95.5577C33.7228 97.1394 34.6644 99.2926 34.7235 101.558Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M33.4704 97.0783L17.3467 113.202V107.428L30.6039 94.1704C31.7791 94.8953 32.7624 95.8928 33.4704 97.0783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M34.5056 99.6379L17.3652 116.778V115.555L34.2337 98.71C34.3475 99.012 34.4384 99.3222 34.5056 99.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M26.8508 92.9116L17.3467 102.416V101.559C17.3447 100.989 17.4002 100.421 17.5122 99.8623L24.3388 93.0357C24.8952 92.9234 25.4616 92.8679 26.0292 92.8702C26.3036 92.8688 26.5779 92.8826 26.8508 92.9116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M34.7176 101.405H17.3408V102.534H34.7176V101.405Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M23.4336 101.411V92.5215H22.3047V101.411H23.4336Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M29.7646 101.404V92.5151H28.6357V101.404H29.7646Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M37.6611 118.333H14.3975V122.375H37.6611V118.333Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M74.3231 101.558V118.332H54.6826V101.558C54.7455 98.9956 55.8077 96.5589 57.6425 94.7686C59.4773 92.9782 61.9393 91.9761 64.5028 91.9761C67.0664 91.9761 69.5284 92.9782 71.3632 94.7686C73.198 96.5589 74.2602 98.9956 74.3231 101.558Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M73.1883 101.559V117.204H55.8115V101.559C55.8115 99.2542 56.7269 97.0443 58.3563 95.4149C59.9857 93.7855 62.1956 92.8701 64.4999 92.8701C66.8042 92.8701 69.0141 93.7855 70.6435 95.4149C72.2729 97.0443 73.1883 99.2542 73.1883 101.559Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M71.9422 97.0783L55.8125 113.202V107.428L69.0697 94.1704C70.2467 94.8951 71.2319 95.8925 71.9422 97.0783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M72.9763 99.6379L55.8359 116.778V115.555L72.7044 98.71C72.8156 99.0129 72.9065 99.3229 72.9763 99.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M65.3225 92.9116L55.8125 102.416V101.559C55.8134 100.989 55.8689 100.421 55.978 99.8623L62.8046 93.0357C63.363 92.9236 63.9313 92.8682 64.5009 92.8702C64.7753 92.8691 65.0496 92.8829 65.3225 92.9116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M73.1883 101.405H55.8115V102.534H73.1883V101.405Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M61.9053 101.404V92.5151H60.7764V101.404H61.9053Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M68.2295 101.404V92.5151H67.1006V101.404H68.2295Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M76.1317 118.333H52.8682V122.375H76.1317V118.333Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M112.789 101.558V118.332H93.1484V101.558C93.2113 98.9956 94.2735 96.5589 96.1083 94.7686C97.9431 92.9782 100.405 91.9761 102.969 91.9761C105.532 91.9761 107.994 92.9782 109.829 94.7686C111.664 96.5589 112.726 98.9956 112.789 101.558Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M111.654 101.559V117.204H94.2773V101.559C94.2773 99.2542 95.1927 97.0443 96.8221 95.4149C98.4515 93.7855 100.661 92.8701 102.966 92.8701C105.27 92.8701 107.48 93.7855 109.109 95.4149C110.739 97.0443 111.654 99.2542 111.654 101.559Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M110.407 97.0783L94.2773 113.202V107.428L107.535 94.1704C108.712 94.8951 109.697 95.8925 110.407 97.0783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M111.441 99.6379L94.3008 116.778V115.555L111.157 98.71C111.273 99.0126 111.367 99.3226 111.441 99.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M103.787 92.9116L94.2773 102.416V101.559C94.2783 100.989 94.3337 100.421 94.4428 99.8623L101.269 93.0357C101.828 92.9236 102.396 92.8682 102.966 92.8702C103.24 92.8691 103.514 92.8829 103.787 92.9116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M111.654 101.405H94.2773V102.534H111.654V101.405Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M100.37 101.404V92.5151H99.2412V101.404H100.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M106.695 101.404V92.5151H105.566V101.404H106.695Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M114.598 118.333H91.334V122.375H114.598V118.333Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M35.8524 61.4089V78.1828H16.2119V61.4089C16.1798 60.099 16.41 58.7959 16.8891 57.5763C17.3682 56.3568 18.0864 55.2454 19.0015 54.3076C19.9165 53.3698 21.01 52.6245 22.2174 52.1157C23.4249 51.6069 24.7219 51.3447 26.0322 51.3447C27.3425 51.3447 28.6395 51.6069 29.8469 52.1157C31.0544 52.6245 32.1478 53.3698 33.0629 54.3076C33.978 55.2454 34.6962 56.3568 35.1752 57.5763C35.6543 58.7959 35.8846 60.099 35.8524 61.4089Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M34.7235 61.4085V77.0535H17.3408V61.4085C17.3999 59.1427 18.3415 56.9895 19.965 55.4078C21.5885 53.8261 23.7655 52.9409 26.0322 52.9409C28.2988 52.9409 30.4758 53.8261 32.0993 55.4078C33.7228 56.9895 34.6644 59.1427 34.7235 61.4085Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M33.4704 56.9289L17.3467 73.0527V67.2782L30.6039 54.021C31.7791 54.7459 32.7624 55.7434 33.4704 56.9289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M34.5056 59.4879L17.3652 76.6282V75.4048L34.2337 58.5186C34.3485 58.8344 34.4393 59.1584 34.5056 59.4879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M26.8508 52.7617L17.3467 62.2657V61.4087C17.3447 60.8391 17.4002 60.2708 17.5122 59.7124L24.3388 52.8858C24.8952 52.7735 25.4616 52.718 26.0292 52.7203C26.3036 52.7189 26.5779 52.7327 26.8508 52.7617Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M34.7176 61.2549H17.3408V62.3838H34.7176V61.2549Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M23.4336 61.2609V52.3716H22.3047V61.2609H23.4336Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M29.7588 61.2551V52.3657H28.6299V61.2551H29.7588Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M37.6611 78.1826H14.3975V82.2254H37.6611V78.1826Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M57.6684 23.4931H32.874C32.874 17.3995 38.418 12.4524 45.286 12.4524C52.154 12.4524 57.6684 17.3995 57.6684 23.4931Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M55.0848 24.8288V35.704H35.4444V24.8288C35.4122 23.5189 35.6425 22.2158 36.1215 20.9963C36.6006 19.7767 37.3188 18.6653 38.2339 17.7275C39.149 16.7897 40.2424 16.0445 41.4498 15.5356C42.6573 15.0268 43.9543 14.7646 45.2646 14.7646C46.5749 14.7646 47.8719 15.0268 49.0794 15.5356C50.2868 16.0445 51.3802 16.7897 52.2953 17.7275C53.2104 18.6653 53.9286 19.7767 54.4077 20.9963C54.8867 22.2158 55.117 23.5189 55.0848 24.8288Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M53.9559 24.8291V34.5636H36.5791V24.8291C36.58 24.2577 36.6354 23.6877 36.7446 23.1268C37.0813 21.4421 37.9093 19.8947 39.1241 18.6798C40.339 17.4649 41.8864 16.637 43.5712 16.3003C44.13 16.1911 44.6981 16.1357 45.2675 16.1348C45.5453 16.1348 45.8172 16.1348 46.089 16.1761C47.4191 16.2985 48.7022 16.7296 49.8363 17.4351C51.0107 18.1631 51.9952 19.1598 52.7087 20.343C53.0176 20.8524 53.2712 21.3933 53.4653 21.9566C53.5792 22.2671 53.672 22.5851 53.7431 22.9082C53.8861 23.5384 53.9575 24.1828 53.9559 24.8291Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M52.709 20.355L38.4588 34.5756H36.5557V30.7042L49.8128 17.447C50.9972 18.1704 51.9904 19.1677 52.709 20.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M53.7432 22.9201L42.0819 34.5755H40.8584L53.4713 21.9685C53.586 22.2783 53.6769 22.5964 53.7432 22.9201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M46.089 16.1882L36.5791 25.6981V24.8293C36.58 24.2579 36.6354 23.6879 36.7446 23.1271L43.5712 16.3005C44.13 16.1914 44.6981 16.1359 45.2675 16.135C45.5512 16.1468 45.8172 16.1646 46.089 16.1882Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M53.9559 24.6812H36.5791V25.8101H53.9559V24.6812Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M42.667 24.687V15.7976H41.5381V24.687H42.667Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M48.9912 24.687V15.7976H47.8623V24.687H48.9912Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M56.8993 35.7041H33.6357V39.7469H56.8993V35.7041Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M96.1508 23.4931H71.3564C71.3564 17.3995 76.9064 12.4524 83.7684 12.4524C90.6305 12.4524 96.1508 17.3995 96.1508 23.4931Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M93.5732 24.8288V35.704H73.9209V24.8288C73.8888 23.5189 74.119 22.2158 74.5981 20.9963C75.0772 19.7767 75.7954 18.6653 76.7104 17.7275C77.6255 16.7897 78.719 16.0445 79.9264 15.5356C81.1339 15.0268 82.4309 14.7646 83.7412 14.7646C85.0514 14.7646 86.3485 15.0268 87.5559 15.5356C88.7634 16.0445 89.8568 16.7897 90.7719 17.7275C91.687 18.6653 92.4052 19.7767 92.8842 20.9963C93.3633 22.2158 93.5935 23.5189 93.5614 24.8288H93.5732Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M92.4452 24.8291V34.5636H75.0684V24.8291C75.0664 24.2575 75.1218 23.6873 75.2339 23.1268C75.5706 21.4421 76.3986 19.8947 77.6134 18.6798C78.8283 17.4649 80.3757 16.637 82.0605 16.3003C82.6173 16.1908 83.1834 16.1354 83.7509 16.1348C84.0287 16.1348 84.3065 16.1348 84.5724 16.1761C85.9255 16.3021 87.2299 16.745 88.38 17.4689C89.5301 18.1928 90.4935 19.1774 91.1922 20.343C91.5052 20.851 91.761 21.3922 91.9546 21.9566C92.0693 22.2664 92.1602 22.5845 92.2265 22.9082C92.3742 23.5377 92.4476 24.1824 92.4452 24.8291Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M91.1912 20.355L76.9647 34.5756H75.0615V30.7042L88.3187 17.447C89.4944 18.1734 90.4793 19.1704 91.1912 20.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M92.2442 22.9201L80.5828 34.5755H79.3594L91.9723 21.9685C92.087 22.2783 92.1779 22.5964 92.2442 22.9201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M84.5597 16.188L75.0557 25.6979V24.8291C75.0537 24.2575 75.1092 23.6873 75.2212 23.1268L82.0478 16.3003C82.6046 16.1908 83.1707 16.1354 83.7382 16.1348C84.0278 16.1466 84.3056 16.1643 84.5597 16.188Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M92.4393 24.6812H75.0625V25.8101H92.4393V24.6812Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M81.1562 24.687V15.7976H80.0273V24.687H81.1562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M87.4805 24.687V15.7976H86.3516V24.687H87.4805Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M95.3817 35.7041H72.1182V39.7469H95.3817V35.7041Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M112.789 61.4089V78.1828H93.1485V61.4089C93.1163 60.099 93.3466 58.7959 93.8256 57.5763C94.3047 56.3568 95.0229 55.2454 95.938 54.3076C96.8531 53.3698 97.9465 52.6245 99.1539 52.1157C100.361 51.6069 101.658 51.3447 102.969 51.3447C104.279 51.3447 105.576 51.6069 106.783 52.1157C107.991 52.6245 109.084 53.3698 109.999 54.3076C110.914 55.2454 111.633 56.3568 112.112 57.5763C112.591 58.7959 112.821 60.099 112.789 61.4089Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M111.654 61.4086V77.0536H94.2773V61.4086C94.2773 59.1043 95.1927 56.8944 96.8221 55.265C98.4515 53.6356 100.661 52.7202 102.966 52.7202C105.27 52.7202 107.48 53.6356 109.109 55.265C110.739 56.8944 111.654 59.1043 111.654 61.4086Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M110.407 56.9289L94.2773 73.0527V67.2782L107.535 54.021C108.712 54.7457 109.697 55.7431 110.407 56.9289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M111.441 59.4884L94.3008 76.6287V75.4052L111.157 58.519C111.273 58.8355 111.368 59.1593 111.441 59.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M103.787 52.7621L94.2773 62.2662V61.4091C94.2783 60.8397 94.3337 60.2717 94.4428 59.7128L101.269 52.8863C101.828 52.7742 102.396 52.7188 102.966 52.7208C103.24 52.7197 103.514 52.7335 103.787 52.7621Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M111.654 61.2549H94.2773V62.3838H111.654V61.2549Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M100.37 61.2551V52.3657H99.2412V61.2551H100.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M106.695 61.2551V52.3657H105.566V61.2551H106.695Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M114.598 78.1826H91.334V82.2254H114.598V78.1826Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M74.3182 61.4089V78.1828H54.6778V61.4089C54.6456 60.099 54.8759 58.7959 55.3549 57.5763C55.834 56.3568 56.5522 55.2454 57.4673 54.3076C58.3824 53.3698 59.4758 52.6245 60.6832 52.1157C61.8907 51.6069 63.1877 51.3447 64.498 51.3447C65.8083 51.3447 67.1053 51.6069 68.3128 52.1157C69.5202 52.6245 70.6136 53.3698 71.5287 54.3076C72.4438 55.2454 73.162 56.3568 73.6411 57.5763C74.1201 58.7959 74.3504 60.099 74.3182 61.4089Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M73.1883 61.4086V77.0536H55.8115V61.4086C55.8115 60.2676 56.0363 59.1378 56.4729 58.0837C56.9095 57.0296 57.5495 56.0718 58.3563 55.265C59.1631 54.4582 60.1209 53.8182 61.175 53.3816C62.2291 52.9449 63.3589 52.7202 64.4999 52.7202C65.6409 52.7202 66.7707 52.9449 67.8248 53.3816C68.8789 53.8182 69.8367 54.4582 70.6435 55.265C71.4503 56.0718 72.0903 57.0296 72.5269 58.0837C72.9636 59.1378 73.1883 60.2676 73.1883 61.4086Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M71.9422 56.9285L55.8125 73.0522V67.2777L69.0697 54.0205C70.2454 54.7469 71.2303 55.7439 71.9422 56.9285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M72.9763 59.4879L55.8359 76.6282V75.4048L72.6985 58.5186C72.8124 58.8352 72.9052 59.159 72.9763 59.4879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M65.3225 52.7616L55.8125 62.2657V61.4087C55.8134 60.8392 55.8689 60.2712 55.978 59.7124L62.8046 52.8858C63.363 52.7737 63.9313 52.7183 64.5009 52.7203C64.7753 52.7192 65.0496 52.733 65.3225 52.7616Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M73.1883 61.2549H55.8115V62.3838H73.1883V61.2549Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M61.9004 61.2551V52.3657H60.7715V61.2551H61.9004Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M68.2295 61.255V52.3657H67.1006V61.255H68.2295Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M76.1317 78.1826H52.8682V82.2254H76.1317V78.1826Z",
    fill: "#EBEBEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBuilding);
export default __webpack_public_path__ + "static/media/multi-building.236b0ed8b57ba4762b505b3b8cc2eede.svg";
export { ForwardRef as ReactComponent };